import { useState } from "react";
import { motion } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

const faqs = [
  {
    question: "What services does Glide Education offer?",
    answer:
      "We offer student counseling, Australian university selection, visa application support, test preparation, and post-arrival guidance.",
  },
  {
    question: "Can I apply to study or migrate to other countries?",
    answer:
      "Glide Education is fully focused on Australia. We specialize in helping students and migrants succeed in Australia.",
  },
  {
    question: "Do I need IELTS or PTE to study in Australia?",
    answer:
      "Yes, most Australian universities require proof of English proficiency. We provide support for both IELTS and PTE preparation.",
  },
  {
    question: "How long does it take to get an Australian student visa?",
    answer:
      "Processing times vary, but it typically takes 4–8 weeks. We Assist you prepare everything to avoid delays.",
  },
  {
    question: "Can Glide Assist me with PR pathways after graduation?",
    answer:
      "Absolutely! We provide guidance on Permanent Residency pathways available after completing studies in Australia.",
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="py-16 px-6 sm:px-10 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-blue-700 mb-8 text-center">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow p-4 cursor-pointer"
              onClick={() => toggle(index)}
            >
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold text-gray-800">
                  {faq.question}
                </h3>
                <FaChevronDown
                  className={`transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </div>
              {openIndex === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  transition={{ duration: 0.3 }}
                  className="mt-2 text-gray-600"
                >
                  {faq.answer}
                </motion.div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
